export function normalizeHeader(value: unknown, index: number) {
	const normalized = String(value || "")
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "_")
		.replace(/\s+/g, "_");
	return normalized.length > 0 ? normalized : `column_${index + 1}`;
}

export function valueToString(value: unknown): string {
	if (value === null || value === undefined) return "";
	if (value instanceof Date) return value.toISOString();
	return String(value).trim();
}

export function parseBoolean(value: string): boolean {
	const normalized = value.trim().toLowerCase();
	return ["true", "1", "yes", "y", "x"].includes(normalized);
}

export function checkHeaderMatch(header: string, header2: string): boolean {
	const normalizedHeaderWithoutUnderscore = header.replace(/_/g, "");
	const directMatch: boolean = header === header2;
	const relaxedMatch: boolean = normalizedHeaderWithoutUnderscore === header2;
	const matchingCanonical = directMatch || relaxedMatch;

	return matchingCanonical;
}
